import React, { Component } from "react";
import { observer } from "mobx-react";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { Web3Store } from "../stores/web3Store";
import { RootStore } from "../stores/rootStore";
import { Avatar, Tooltip, Image } from "antd";
import { Swiper, SwiperSlide } from "swiper/react/swiper-react";
import "swiper/swiper.less";
import { Navigation } from "swiper";
import { IArtist, IBrandRelatedIP, IMythServerResponse, INFTBrand } from "../bean/ResponseBean";
import "../styles/brandInfo.less";
import { LeftCircleOutlined, RightCircleOutlined } from "@ant-design/icons";
import { getRoutePath, MythRouteId } from "../router-config";
import { MythServerResultCode } from "../constant/CommonConstant";
import logger from "../logger";
import { handleNFTName } from "../utils/commonUtils";
import NoData from "../components/noData";

interface IProps {
    web3Store: Web3Store;
    rootStore: RootStore;
}

interface IStates {
    brandInfo: INFTBrand,
    team: IArtist[]
}

type IBrandInfo = IProps & RouteComponentProps;

@observer
class BrandInfo extends Component<IBrandInfo, IStates> {
    constructor(props: IBrandInfo, state: IStates) {
        super(props);
        this.state = {
            brandInfo: {
                id: 0,
                name: "",
                logo: "",
                productType: "",
                banner: "",
                place: "",
                twitter: "",
                discord: "",
                website: "",
                images: "",
                imageArray: [],
                description: "",
                rank: 0,
                ips: [],
                brandCollections: []
            },
            team: []
        }
    }

    componentDidMount(): void {
        this.getNFTBrand();
    }

    getNFTBrand = async () => {
        const { web3Store } = this.props;
        let locationState: any = this.props.location.state;
        const brandId = locationState && locationState.brandId ? locationState.brandId : 0;
        try {
            if (web3Store.mythServerApi && brandId > 0) {
                const result: IMythServerResponse<INFTBrand> = await web3Store.mythServerApi.getNFTBrand(brandId);
                if (result.resultCode === MythServerResultCode.SUCCESS) {
                    const data = result.resultValue;
                    if (data) {
                        if (data.images) {
                            const urlPrefix = data.images.substring(0, data.images.indexOf("?"));
                            const ids = data.images.substring(data.images.indexOf("?") + 1, data.images.lastIndexOf("."));
                            const imageSuffix = data.images.substring(data.images.lastIndexOf("."));
                            const array = ids.split("-");
                            data.imageArray = [];
                            if (array && array.length === 2) {
                                for (let i = Number.parseInt(array[0]); i <= Number.parseInt(array[1]); i++) {
                                    const url = urlPrefix + "/" + i + imageSuffix;
                                    data.imageArray.push(url);
                                }
                            }
                        }
                        this.setState({
                            brandInfo: data
                        });
                    }
                }
            }
        } catch (e) {
            logger.error(e);
        }
    };

    onClickIPItem = (item: IBrandRelatedIP) => {
        const url = getRoutePath(MythRouteId.OnePage) + "?ipId=" + item.ipId;
        this.props.history.push(url);
    };

    onClickUserItem = (item: IArtist) => {
        this.props.history.push({
            pathname: getRoutePath(MythRouteId.UserCenter),
            state: { userId: item.userId }
        });
    };

    render() {
        const { brandInfo, team } = this.state;
        let collectionLogo = "";
        let collectionName = "Multi";
        if (brandInfo.brandCollections && brandInfo.brandCollections.length > 0) {
            collectionLogo = brandInfo.brandCollections[0].collectionLogo;
            collectionName = brandInfo.brandCollections[0].collectionName;
        }
        return <div className="brand-info-container">
            <img src={brandInfo.banner} className="brand-banner" alt="banner" />
            <div className="brand-section">
                <div className="info-content">
                    <div className="text-center">
                        <Avatar src={brandInfo.logo} className="brand-logo" />
                        <p className="brand-name">{brandInfo.name}</p>
                    </div>
                    <p className="description font-18">{brandInfo.description}</p>
                </div>
                <div className="brand-info-more myth-panel flex-row">
                    <div className="info-item">
                        <div className="info-label">Category</div>
                        <div className="info-content bold">{brandInfo.productType}</div>
                    </div>
                    <div className="info-item">
                        <div className="info-label">Location</div>
                        <div className="info-content bold">{brandInfo.place}</div>
                    </div>
                    <div className="info-item">
                        <div className="info-label">Collection</div>
                        <div className="info-content">
                            {collectionLogo.length > 0 ?
                                <img className="info-img" src={collectionLogo} alt="" /> : ""
                            }
                            <b className="collection-name">{collectionName}</b>
                        </div>
                    </div>
                    <div className="info-item">
                        <div className="info-label">Level</div>
                        <div className="info-content bold">
                            {new Array(brandInfo.rank).fill(0).map((item, index) => (
                                <i key={index} className="iconfont icon-star"
                                    style={{ color: "#fead00" }}></i>
                            ))}
                        </div>
                    </div>
                    <div className="info-item link-item">
                        <div className="info-label">Social Info</div>
                        <div className="info-content link-content">
                            {
                                brandInfo.twitter && <a href={brandInfo.twitter} target="_blank" rel="noreferrer"><i
                                    className="iconfont icon-twitter"></i></a>
                            }
                            {
                                brandInfo.discord && <a href={brandInfo.discord} target="_blank" rel="noreferrer"><i
                                    className="iconfont icon-discord"></i></a>
                            }
                            {
                                brandInfo.website && <a href={brandInfo.website} target="_blank" rel="noreferrer"><i
                                    className="iconfont icon-global"></i></a>
                            }
                        </div>
                    </div>
                </div>
                {brandInfo.imageArray && brandInfo.imageArray.length > 0 && <div className="brand-image-container">
                    <Swiper
                        slidesPerView="auto"
                        slidesPerGroup={3}
                        navigation={{
                            nextEl: ".swiper-next-brand",
                            prevEl: ".swiper-prev-brand",
                            disabledClass: "disabled"
                        }}
                        modules={[Navigation]}
                        className="market-swiper"
                    >
                        {brandInfo.imageArray.map((item: string, index: number) => (
                            <SwiperSlide key={index} className="img-swiper-item">
                                <div>
                                    <Image src={item} rootClassName="image-item" style={{ width: '100%', height: '100%', objectFit: 'cover' }}></Image>
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                    <LeftCircleOutlined className="swiper-prev swiper-prev-brand" />
                    <RightCircleOutlined className="swiper-next swiper-next-brand" />
                </div>}

                <div className="list-title">Related IPs</div>
                {
                    brandInfo.ips && brandInfo.ips.length > 0 ?
                        <div className="flex-row brand-ip-list">
                            {brandInfo.ips.map((item, index) => (
                                <div className="ip-item" key={"ip-" + index} onClick={event => this.onClickIPItem(item)}>
                                    <div className="ip-img">
                                        <img src={item.image} alt="" />
                                    </div>
                                    <Tooltip title={handleNFTName(item.collectionName, item.tokenId)}>
                                        <div
                                            className="text-center ip-name">{handleNFTName(item.collectionName, item.tokenId)}</div>
                                    </Tooltip>
                                </div>
                            ))}
                        </div> : <NoData />
                }
                <div className="list-title">Team</div>
                {
                    team && team.length > 0 ?
                        <div className="flex-row">
                            {team.map((item, i) => (
                                <div className="team-item" onClick={event => this.onClickUserItem(item)}>
                                    <div className="team-img">
                                        <img src={item.avatar} alt="" />
                                    </div>
                                    <div className="text-center team-name">{item.name}</div>
                                </div>
                            ))}
                        </div> : <NoData />
                }
            </div>
        </div >
    }
}

export default withRouter(BrandInfo);
